import Switch, { SwitchProps } from '@mui/material/Switch';
import { Checkbox, styled } from '@mui/material';


export default function SwitchField(props: {
    label?: string | null;
    readOnly?: boolean;
    value?: boolean;
    onChange: (value: boolean) => void;
    testId?: string;
    ariaLabel?: string;
    showAsCheck?: boolean;
    compact?: boolean;
}) {
    return (
        <div
            style={{ opacity: props.readOnly == true ? 0.5 : 1 }}
        >
            {props.label && (
                <div style={props.compact ? {} : { marginTop: 10, marginLeft: 10 }}>
                    <small style={{ color: "gray" }}>{props.label}</small>
                </div>
            )}

            {props.showAsCheck == true && (<Checkbox
                color="secondary"
                disableRipple
                data-testid={props.testId}
                slotProps={{ input: { 'aria-label': props.ariaLabel } }}
                checked={props.value == true}
                onChange={(e) => {
                    props.onChange(e.target.checked);
                }}
                readOnly={props.readOnly}
                disabled={props.readOnly}
            />)}

            {props.showAsCheck != true && (<IOSSwitch
                disableRipple
                data-testid={props.testId}
                slotProps={{ input: { 'aria-label': props.ariaLabel, role: 'switch' } }}
                sx={{
                    width: 42,
                    height: 26,
                    padding: 0,
                    margin: props.compact ? (theme) => `${theme.spacing(1)} 0` : (theme) => theme.spacing(1),
                }}
                checked={props.value == true}
                onChange={(e) => {
                    props.onChange(e.target.checked);
                }}
                readOnly={props.readOnly}
                disabled={props.readOnly}
            />)}
        </div>
    );
};


// this is the v5 version of the v4 IOSSwitch that we've used
const IOSSwitch = styled((props: SwitchProps) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#65C466',
                opacity: 1,
                border: 0,
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#33cf4d',
            border: '6px solid #fff',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color:
                theme.palette.mode === 'light'
                    ? theme.palette.grey[100]
                    : theme.palette.grey[600],
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 22,
        height: 22,
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
    },
}));
